import { UpperCasePipe } from '@angular/common';
import { Component, inject, linkedSignal, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserDataService } from '../../services/user-data.service';
import { Brand } from '../../models/brand';
import { CouponResponse } from '../../models/coupon-response';
import { Modal, ModalDismissReasons } from '../../services/modal.service';

@Component({
  selector: 'modal-coupon-ok',
  imports: [TranslatePipe, UpperCasePipe],
  templateUrl: './coupon-ok.component.html',
  styleUrls: ['./coupon-ok.component.scss']
})
export class CouponOKComponent implements OnInit {

  private modal = inject(Modal);
  private userDataService = inject(UserDataService);

  email = linkedSignal(() => this.userDataService.user()?.email ?? '');

  withAppSessionBlock = false;
  wonMonths = 0;
  wonAnalysis = false;
  wonVideoTitles: Array<string> = [];
  wonBrands: Array<Brand> = [];

  ngOnInit(): void {
    const response: CouponResponse = this.modal.params.response;
    this.wonMonths = response.duration;
    this.wonAnalysis = response.analysis;
    this.wonBrands = response.brands;
    this.wonVideoTitles = response.videos.map(x => x.title);
    this.withAppSessionBlock = response.withAppSessionBlock;
  }

  close() {
    this.modal.dismiss(ModalDismissReasons.OK);
  }

}
